"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FarmWrapper = void 0;
const web3_js_1 = require("@solana/web3.js");
const landlord_1 = require("./landlord");
class FarmWrapper {
    constructor(saber) {
        this.saber = saber;
        this.program = saber.programs.Farm;
    }
    createLandlordIx({ dailyRewardsRate, base, authority = this.program.provider.wallet.publicKey, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const [landlordKey, bump] = yield this.generateLandlordAddress(base);
            const mintProxyState = yield this.saber.programs.MintProxy.state.fetch();
            return {
                key: landlordKey,
                base,
                ix: this.program.instruction.newLandlord(base, bump, dailyRewardsRate, {
                    accounts: {
                        authority,
                        landlord: landlordKey,
                        payer: this.program.provider.wallet.publicKey,
                        systemProgram: web3_js_1.SystemProgram.programId,
                        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                        clock: web3_js_1.SYSVAR_CLOCK_PUBKEY,
                        mintProxyProgram: this.saber.programs.MintProxy.programId,
                        rewardsTokenMint: mintProxyState.tokenMint,
                    },
                }),
            };
        });
    }
    createLandlord({ dailyRewardsRate, landlordBase = web3_js_1.Keypair.generate().publicKey, authority = this.program.provider.wallet.publicKey, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const { key, base, ix } = yield this.createLandlordIx({
                dailyRewardsRate,
                base: landlordBase,
                authority,
            });
            return {
                landlord: key,
                base,
                tx: this.saber.newTx([ix]),
            };
        });
    }
    generateLandlordAddress(base) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield web3_js_1.PublicKey.findProgramAddress([
                Buffer.from([76, 97, 110, 100, 108, 111, 114, 100]),
                base.toBuffer(),
            ], this.program.programId);
        });
    }
    /**
     * Loads the landlord wrapper.
     * @param landlord
     * @returns
     */
    loadLandlordWrapper(landlord) {
        return __awaiter(this, void 0, void 0, function* () {
            const landlordData = yield this.program.account.landlord.fetch(landlord);
            return new landlord_1.LandlordWrapper(this, landlord, landlordData);
        });
    }
}
exports.FarmWrapper = FarmWrapper;
//# sourceMappingURL=index.js.map